import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'styled-components';
import styled from '@utils/styled-px2rem';

import { Checkbox as Icon } from '@icons/common';

const DEFAULT_OPTIONS = {
  enableUncheckOnDisabled: false,
};

class Checkbox extends React.PureComponent {
  get options() {
    const { options } = this.props;
    return { ...DEFAULT_OPTIONS, ...options };
  }

  get isCheckBoxDisabled() {
    const { disabled, checked } = this.props;
    const { enableUncheckOnDisabled } = this.options;
    return disabled && !(enableUncheckOnDisabled && checked);
  }

  render() {
    const { className, checked, children, disabled, inputRef, ...props } =
      this.props;

    const isDescribed = !!children;

    return (
      <StyledLabel className={className} disabled={disabled} checked={checked}>
        <StyledWrapper described={isDescribed}>
          <StyledCheckbox
            {...props}
            checked={checked}
            disabled={this.isCheckBoxDisabled}
            ref={inputRef}
          />
          {checked && <StyledIcon disabled={disabled} />}
        </StyledWrapper>
        {children}
      </StyledLabel>
    );
  }
}

const StyledCheckbox = styled.input.attrs({
  type: 'checkbox',
})`
  pointer-events: auto;
  cursor: pointer;
  appearance: none;
  display: block;
  height: 16px;
  width: 16px;
  border: 0;

  &:after {
    border: 1px solid #919499;
    border-radius: 2px;
    box-sizing: border-box;
    content: '';
    display: block;
    height: 100%;
    width: 100%;
  }

  ${props =>
    !props.disabled &&
    css`
      cursor: pointer;
    `}

  ${props =>
    props.disabled &&
    `
      &:after {
        border: 1px dashed #919499;
      }
    `}
`;

const StyledLabel = styled.label`
  display: flex;

  ${StyledCheckbox} {
    ${({ checked, disabled }) =>
      checked &&
      !disabled &&
      css`
        &:after {
          background-image: linear-gradient(to top, #5bc9f5, #2080f1);
          border: none;
          box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.3);
        }
      `}
  }

  ${props =>
    !props.disabled &&
    css`
      cursor: pointer;
    `}
`;

const StyledWrapper = styled.div`
  position: relative;

  ${props =>
    props.described &&
    css`
      font-size: 0;
      margin-right: 8px;
    `}
`;

const StyledIcon = styled(Icon)`
  height: 13px;
  left: 3px;
  position: absolute;
  stroke: #fff;
  top: 2px;
  width: 10px;
  cursor: pointer;

  path {
    stroke-width: 1px;
  }

  ${props =>
    props.disabled &&
    `
    stroke: #919499;
    cursor: default;
  `}
`;

Checkbox.StyledWrapper = StyledWrapper;

Checkbox.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.shape({
    enableUncheckOnDisabled: PropTypes.bool,
  }),
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.shape({}) }),
  ]),
};

Checkbox.defaultProps = {
  checked: false,
  children: '',
  className: '',
  disabled: false,
  onChange: Function.prototype,
  options: {},
  inputRef: null,
};

export default Checkbox;
